import { FC } from "react";

interface FlagArabicProps {
  className?: string;
}

const FlagArabic: FC<FlagArabicProps> = ({ className }) => {
  return (
    <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clipPath="url(#clip0_flag_arabic)">
        <rect width="24" height="18" rx="3" fill="#00732F" />
        <rect y="6" width="24" height="12" fill="white" />
        <rect y="12" width="24" height="6" fill="black" />
        <rect width="6" height="18" fill="#FF0000" />
      </g>
      <defs>
        <clipPath id="clip0_flag_arabic">
          <rect width="24" height="18" rx="3" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FlagArabic;
